"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework class for MenuButton control
         */
        var MenuButton = /** @class */ (function (_super) {
            __extends(MenuButton, _super);
            function MenuButton() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            MenuButton.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                if (this.element) {
                    this.$flyoutButton = $(this.element).find(".flyoutButton-Button");
                }
                // Index of the Menuitem that is currently highlighted
                if (!$dyn.isObservable(this.ShownIndex)) {
                    this.ShownIndex = $dyn.observable(this.ShownIndex);
                }
                var _shown = false;
                this.ShowFlyout = $dyn.computed(function () {
                    // Once the flyout has been opened once, return the value of _shown. The flyout should remain closed until the server
                    // has opened it for the first time.
                    var hasBeenOpened = $dyn.value(_this.HasBeenOpened);
                    if (hasBeenOpened) {
                        return _shown;
                    }
                    return hasBeenOpened;
                }, function (newValue) {
                    if (newValue) {
                        // If the flyout does not have a server command for Click, it will call the default command defined below,
                        // and directly set the value of HasBeenOpened.
                        _this.Clicked();
                        if (_this.$flyoutButton && _this.$flyoutButton[0] && _this.$flyoutButton[0].dynFocusedTimer) {
                            window.clearTimeout(_this.$flyoutButton[0].dynFocusedTimer);
                            _this.$flyoutButton[0].dynFocusedTimer = undefined;
                        }
                        // Wait until the flyout has all the menuitems
                        if (!$dyn.value($dyn.async.pending)) {
                            _this.initializeMenuItems(false);
                        }
                        else {
                            _this.pendingObserver = $dyn.observe($dyn.async.pending, function (pending) {
                                if (!pending) {
                                    _this.initializeMenuItems(true);
                                    _this.pendingObserver = undefined;
                                    return false;
                                }
                                return true;
                            });
                        }
                    }
                    else {
                        if ($dyn.superTooltip && $dyn.superTooltip._superToolTipControl && _this.$menuElement && $dyn.superTooltip._superToolTipControl.parentElement === _this.$menuElement[0]) {
                            $dyn.superTooltip.destroySuperTooltip();
                        }
                        _this.ShownIndex(-1);
                        if (_this.$menuElement) {
                            _this.$menuElement.removeAttr("aria-activedescendant");
                            _this.$menuElement.off("keydown.appBar", _this.keyDown);
                        }
                    }
                    _shown = newValue;
                });
                this.isControlAvailableForExpando = function () {
                    // Turn off feature for MenuButton till we bring MenuButtonItems from server for personalization
                    return false;
                };
                this.getExpandoPersonalizationFocusTarget = function () {
                    return $(_this.element).find("button");
                };
                this.getCurrentAnchor = function () {
                    return _this.currentAnchor;
                };
                this.optOutFocusTimer = function () {
                    return $dyn.value(_this.ShowFlyout);
                };
            };
            /**
             * The keydown event handler
             * @param event The keydown event
             * @description
             * - [Up] Select next menuitem, or move to the first menuitem if reaches the last menuitem
             * - [Down] Select previous menuitem, or move to the last menuitem if reaches the first menuitem.
             * - [Enter] Click the current menuitem and closes the flyout.
             * - [Tab] Closes the flyout and moves to the next control.
             */
            MenuButton.prototype.keyDown = function (event) {
                var elmTarget = $dyn.context(event.currentTarget);
                // incase if the menuitems are not assigned during the flyout open
                if (elmTarget.$menuElement && elmTarget.$menuElement.length === 0) {
                    elmTarget.$menuElement = $(document).find('.flyoutButton-flyOut[data-dyn-lastvisible="true"]');
                    elmTarget.menuItemCount = elmTarget.$menuElement.find('[data-dyn-role="MenuItem"]:not([aria-hidden])').length;
                }
                $dyn.util.handleShortcuts(elmTarget, event);
            };
            MenuButton.prototype.dispose = function () {
                if (this.pendingObserver) {
                    this.pendingObserver.dispose();
                }
                _super.prototype.dispose.call(this);
            };
            /**
             * Selects the next active menu item in the flyout.
             * This is used in keyboard shortcut handler.
             * @returns True to stop keyboard event propagation
             */
            MenuButton.prototype.getNextMenuItem = function () {
                var origIndex = $dyn.value(this.ShownIndex);
                var indexValue = origIndex;
                for (var i = 1; i < this.menuItemCount; i++) {
                    var currentIndex = (origIndex + i) % this.menuItemCount;
                    var $currentMenuItem = this.$menuElement.find('[data-dyn-role="MenuItem"]:visible').eq(currentIndex);
                    if ($currentMenuItem && $currentMenuItem.length > 0) {
                        indexValue = currentIndex;
                        var activeDescId = $currentMenuItem.attr("id");
                        if (activeDescId) {
                            this.$menuElement.attr("aria-activedescendant", activeDescId);
                        }
                        $currentMenuItem[0].scrollIntoViewIfNeeded();
                        break;
                    }
                }
                if (indexValue !== origIndex) {
                    $dyn.setValue(this, "ShownIndex", indexValue);
                }
                return true;
            };
            /**
             * Selects the previous active menu item in the flyout.
             * This is used in keyboard shortcut handler.
             * @returns True to stop keyboard event propagation
             */
            MenuButton.prototype.getPrevMenuItem = function () {
                var origIndex = $dyn.value(this.ShownIndex);
                var indexValue = origIndex;
                for (var i = 1; i < this.menuItemCount; i++) {
                    var currentIndex = origIndex - i;
                    if (currentIndex < 0) {
                        currentIndex += this.menuItemCount;
                    }
                    var $currentMenuItem = this.$menuElement.find('[data-dyn-role="MenuItem"]:visible').eq(currentIndex);
                    if ($currentMenuItem && $currentMenuItem.length > 0) {
                        indexValue = currentIndex;
                        var activeDescId = $currentMenuItem.attr("id");
                        if (activeDescId) {
                            this.$menuElement.attr("aria-activedescendant", activeDescId);
                        }
                        $currentMenuItem[0].scrollIntoViewIfNeeded();
                        break;
                    }
                }
                if (indexValue !== origIndex) {
                    $dyn.setValue(this, "ShownIndex", indexValue);
                }
                return true;
            };
            /**
             * Clicks the current menu item in the flyout.
             * This is used in keyboard shortcut handlers.
             * @returns True to stop keyboard event propagation
             */
            MenuButton.prototype.clickMenuItem = function () {
                var indexValue = $dyn.value(this.ShownIndex);
                // Close the flyout if no menu item is selected
                if (indexValue === -1 && this.$flyoutButton && this.$flyoutButton.length > 0) {
                    this.$flyoutButton.click();
                }
                else {
                    this.$menuElement
                        .find('[data-dyn-role="MenuItem"]:visible')
                        .eq(indexValue)
                        .click();
                }
                return true;
            };
            /**
             * Initialize menu items if not done explicitly
             * @param movedToBody True if flyout needs to be moved to body otherwise false.
             */
            MenuButton.prototype.initializeMenuItems = function (movedToBody) {
                if (movedToBody) {
                    this.$menuElement = $(document).find('.flyoutButton-flyOut[data-dyn-lastvisible="true"]');
                }
                else {
                    this.$menuElement = $(this.element).find(".flyoutButton-flyOut");
                }
                this.$menuElement.on("keydown.appBar", this.keyDown);
                var menuFocusElement = this.$menuElement;
                setTimeout(function () {
                    // set focus on flyout
                    menuFocusElement.focus();
                });
                if (this.$menuElement.length > 0) {
                    // can't use :visible selector becasue the whole menu might not be shown yet
                    var menuItems = this.$menuElement.find('[data-dyn-role="MenuItem"]:not([aria-hidden])');
                    this.menuItemCount = menuItems.length;
                    if (this.menuItemCount > 0) {
                        var indexValue = $dyn.value(this.ShownIndex);
                        for (var i = 0; i < this.menuItemCount; ++i) {
                            var itemElement = menuItems[i];
                            if (indexValue === -1) {
                                // if the ShownIndex is set to something other than -1, then no need to find the active control
                                indexValue = i;
                                $dyn.setValue(this, "ShownIndex", indexValue);
                                if (itemElement.id) {
                                    this.$menuElement.attr("aria-activedescendant", itemElement.id);
                                }
                                itemElement.scrollIntoViewIfNeeded();
                            }
                            itemElement.setAttribute("aria-posinset", (i + 1).toString());
                            itemElement.setAttribute("aria-setsize", this.menuItemCount.toString());
                        }
                    }
                }
            };
            return MenuButton;
        }($dyn.controls.Button));
        controls.MenuButton = MenuButton;
        // Set default values on the prototype for backwards compatibility
        MenuButton.prototype.Click = function (evt) {
            $dyn.setValue(this, "HasBeenOpened", true);
        };
        MenuButton.prototype.ShownIndex = -1;
        // tslint:disable-next-line:no-string-literal
        MenuButton.prototype["$menuElement"] = null;
        // tslint:disable-next-line:no-string-literal
        MenuButton.prototype["menuItemCount"] = 0;
        // tslint:disable:object-literal-sort-keys
        var menuButtonShortcuts = {
            nextMenuItem: {
                Keys: { keyCode: $dyn.ui.KeyCodes.downArrow },
                Handler: function () {
                    if ($dyn.value(this.ShowFlyout) && this.menuItemCount > 0) {
                        return this.getNextMenuItem();
                    }
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: function () {
                    return $dyn.value(this.ShowFlyout);
                },
                Description: $dyn.label("Button_NextMenuItem"),
            },
            prevMenuItem: {
                Keys: { keyCode: $dyn.ui.KeyCodes.upArrow },
                Handler: function () {
                    if ($dyn.value(this.ShowFlyout) && this.menuItemCount > 0) {
                        return this.getPrevMenuItem();
                    }
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: function () {
                    return $dyn.value(this.ShowFlyout);
                },
                Description: $dyn.label("Button_PrevMenuItem"),
            },
            enterMenuItem: {
                Keys: { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] },
                Handler: function () {
                    if ($dyn.value(this.ShowFlyout) && this.menuItemCount > 0) {
                        return this.clickMenuItem();
                    }
                    else {
                        this.ShowFlyout(true);
                    }
                },
                Description: function () {
                    var description = "";
                    if ($dyn.value(this.ShowFlyout)) {
                        description = $dyn.label("Button_ClickMenuItem");
                    }
                    else {
                        description = $dyn.label("Button_OpenMenu");
                    }
                    return description;
                },
            },
            tabMenuItem: {
                Keys: { keyCode: $dyn.ui.KeyCodes.tab, isShiftKeyAgnostic: true },
                Handler: function () {
                    this.ShowFlyout(false);
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: false,
            },
        };
        MenuButton.prototype.Shortcuts = $dyn.extendPrototype(MenuButton.prototype.Shortcuts, menuButtonShortcuts);
        $dyn.ui.addObservablePropertiesToPrototype(MenuButton.prototype, {
            HasBeenOpened: false,
        });
        /**
         * Framework class for MenuItem control
         */
        var MenuItem = /** @class */ (function (_super) {
            __extends(MenuItem, _super);
            function MenuItem() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            MenuItem.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                // If the Selected is observed already (for example filter field operator selector) then no need to compute it again
                if (!$dyn.isObservable(this.Selected)) {
                    this.SelectedComputed = $dyn.computed(function () {
                        if (_this.element && _this.element.parentElement) {
                            var dynParentContext = _this.getParentContext();
                            if (dynParentContext && dynParentContext.ShownIndex) {
                                var shownIndexValue = $dyn.value(dynParentContext.ShownIndex);
                                var allMenuItems = $(_this.element.parentElement).find('[data-dyn-role="MenuItem"]:not([aria-hidden])');
                                if (shownIndexValue < allMenuItems.length) {
                                    return _this.element === allMenuItems[shownIndexValue];
                                }
                            }
                        }
                        return false;
                    });
                    $dyn.observe(this.SelectedComputed, function (newValue) {
                        _this.Selected = newValue;
                        if ($dyn.util.isTooltipOnFocusEnabled() && _this.Selected && !_this.dynFocusedTimer) {
                            _this.dynFocusedTimer = window.setTimeout(function () {
                                if (_this.element.hasAttribute("dyn-data-supertooltip")) {
                                    $dyn.superTooltip.tryOpenSuperTooltip(_this.element);
                                }
                                window.clearTimeout(_this.dynFocusedTimer);
                                _this.dynFocusedTimer = undefined;
                            }, $dyn.onFocusEvent._focusEventTimeout);
                        }
                        else if (!_this.Selected) {
                            if (_this.dynFocusedTimer) {
                                window.clearTimeout(_this.dynFocusedTimer);
                                _this.dynFocusedTimer = undefined;
                            }
                            if ($dyn.superTooltip && $dyn.superTooltip._superToolTipControl && _this.element && $dyn.superTooltip._superToolTipControl === _this.element) {
                                $dyn.superTooltip.destroySuperTooltip();
                            }
                        }
                    });
                }
            };
            MenuItem.prototype.couldCreateRecord = function () {
                var retVal = _super.prototype.couldCreateRecord.call(this);
                if (!retVal) {
                    var dynParentContext = this.getParentContext();
                    // Special case menu button that has multiple create options that isnt using the create command task
                    // This should ideally be fixed in the interaction layer,
                    // where we know there is a new record and not a disconnected record where we clear the cache.
                    if (dynParentContext && dynParentContext.Name === "ctrlAdd") {
                        retVal = true;
                    }
                }
                return retVal;
            };
            MenuItem.prototype.getParentContext = function () {
                var dynParentContext = $dyn.context($(this.element).closest(".flyoutButton-flyOut")[0]);
                dynParentContext = dynParentContext ? dynParentContext : $dyn.context(this.element.parentElement);
                return dynParentContext;
            };
            return MenuItem;
        }($dyn.controls.Button));
        controls.MenuItem = MenuItem;
        // Set default values on the prototype for backwards compatibility
        MenuItem.prototype.template = "MenuItem";
        $dyn.ui.addPropertiesToPrototype(MenuItem.prototype, {
            Selected: { defaultValue: false },
        });
        /**
         * Framework class for MenuItemSeparator control
         */
        var MenuItemSeparator = /** @class */ (function (_super) {
            __extends(MenuItemSeparator, _super);
            function MenuItemSeparator() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return MenuItemSeparator;
        }($dyn.ui.Control));
        controls.MenuItemSeparator = MenuItemSeparator;
        $dyn.ui.addPropertiesToPrototype(MenuItemSeparator.prototype, {
            Label: { defaultValue: "", observable: true },
            ShowLabel: { defaultValue: true, observable: true },
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=MenuButton.js.map
